export enum ClientAdvanceSettlementSourceType {
  INVOICE = "INVOICE",
  MANUAL = "MANUAL",
}

export const ClientAdvanceSettlementSourceTypeLabel: Record<
  ClientAdvanceSettlementSourceType,
  string
> = {
  [ClientAdvanceSettlementSourceType.INVOICE]: "Invoice",
  [ClientAdvanceSettlementSourceType.MANUAL]: "Manual",
};
